import React from "react";
import { formatWeekHours } from "../../utils/utils";

function ShopDetailsModal({
  shop,
  onClose,
  onQuickContact,
  onSendFiles,
}) {
  const services = [
    ...(shop?.selectedSupplies || []),
    ...(shop?.customSupplies || []),
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white w-full sm:max-w-[520px] sm:rounded-[16px] rounded-t-[20px] max-h-[90vh] overflow-hidden shadow-[0px_8px_40px_rgba(0,0,0,0.18)] flex flex-col">

        {/* Hero */}
        <div className="relative h-[220px] overflow-hidden shrink-0">
          <img
            src={shop?.shopPhoto || `https://images.unsplash.com/photo-1767974785671-cfc4c8727147?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwcmludCUyMHNob3AlMjBzdG9yZWZyb250JTIwbW9kZXJufGVufDF8fHx8MTc3MjU2NDg3NHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral`}
            alt={shop?.shopName}
            className="w-full h-full object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

          {/* Close */}
          <button
            onClick={onClose}
            className="absolute top-[12px] right-[12px] w-[32px] h-[32px] rounded-full bg-black/40 backdrop-blur-[4px] flex items-center
           justify-center hover:bg-black/60 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-x w-[16px] h-[16px] text-white">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>

          {/* Type badges */}
          <div className="absolute top-[12px] left-[12px] flex gap-[6px]">
            {shop.type === "printShop" && (
              <span className="bg-[#ff5323] text-white text-[11px] px-[8px] py-[4px] rounded-[6px]">
                On-Demand Print
              </span>
            )}

            {shop.type === "specialist" && (
              <span className="bg-[#6b5dd3] text-white text-[11px] px-[8px] py-[4px] rounded-[6px]">
                Specialist Print
              </span>
            )}

            {shop.type === "supplier" && (
              <span className="bg-black/70 text-white text-[11px] px-[8px] py-[4px] rounded-[6px]">
                Supplier
              </span>
            )}
          </div>

          {/* Bottom Info */}
          <div className="absolute bottom-[16px] left-[16px] right-[16px]">
            <h2 className="font-semibold text-[22px] text-white mb-[4px]">{shop?.shopName}</h2>
            <div className="flex items-center gap-[12px]">
              {/* <div className="flex items-center gap-[4px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" class="lucide lucide-star w-[14px] h-[14px] fill-[#ff5323] text-[#ff5323]">
                  <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                </svg>
                <span className="font-semibold text-[14px] text-white">
                  {shop.reviews !== undefined && shop.reviews !== null && shop.reviews !== ""
                    ? Number(shop.reviews).toFixed(1)
                    : "N/A"}
                </span>
              </div> */}
              {/* <span className="font-medium text-[13px] text-white/70">0.3 km</span> */}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="overflow-y-auto flex-1 px-[20px] sm:px-[24px] py-[20px] flex flex-col gap-[20px]">

          {/* Address */}
          <div className="flex flex-col gap-[10px]">
            <div className="flex items-center gap-[8px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-map-pin w-[16px] h-[16px] text-[#ff5323] shrink-0">
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span className="font-medium text-[14px] text-[#212326]">
                {shop?.address?.street},{" "}
                {shop?.address?.city},{" "}
                {shop?.address?.province}
              </span>
            </div>
            <div className="flex items-center gap-[8px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-clock w-[16px] h-[16px] text-[#ff5323] shrink-0">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              <span className="font-medium text-[14px] text-[#212326]">
                {formatWeekHours(shop?.workingHours)}
              </span>
            </div>
          </div>


          {/* About */}
          <div>
            <h3 className="font-semibold text-[15px] text-[#212326] mb-[8px]">About</h3>
            <p className="font-medium text-[13px] text-[#717182] leading-[1.7]">
              {shop?.description ||
                "No description available."}
            </p>
          </div>


          {/* Services */}
          <div className="flex items-center gap-[6px] mb-[10px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-tag w-[14px] h-[14px] text-[#ff5323]">
              <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
              <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>
            </svg>
            <h3 className="font-semibold text-[15px] text-[#212326]">Services offered</h3>
          </div>

          <div className="flex flex-wrap gap-[6px]">
            {services.map((service, index) => (
              <span
                key={index}
                className="bg-[#f4f5f6] px-[10px] py-[4px] rounded-[8px] font-medium text-[12px] text-[#53585f]"
              >
                {service}
              </span>
            ))}
          </div>


          {/* Current Specials */}
          {shop?.currentSpecials?.length > 0 && (
            <>
              <div className="flex items-center gap-[6px] mb-[10px]">
                <svg
                  width="10"
                  height="13"
                  viewBox="0 0 10 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.62565 7.29171C3.01243 7.29171 3.38336 7.13806 3.65685 6.86457C3.93034 6.59108 4.08398 6.22015 4.08398 5.83337C4.08398 5.02837 3.79232 4.66671 3.50065 4.08337C2.87532 2.83329 3.36998 1.71854 4.66732 0.583374C4.95898 2.04171 5.83398 3.44171 7.00065 4.37504C8.16732 5.30837 8.75065 6.41671 8.75065 7.58337C8.75065 8.1196 8.64503 8.65058 8.43983 9.146C8.23462 9.64141 7.93384 10.0916 7.55467 10.4707C7.1755 10.8499 6.72535 11.1507 6.22994 11.3559C5.73453 11.5611 5.20355 11.6667 4.66732 11.6667C4.13109 11.6667 3.60011 11.5611 3.10469 11.3559C2.60928 11.1507 2.15914 10.8499 1.77996 10.4707C1.40079 10.0916 1.10002 9.64141 0.89481 9.146C0.689603 8.65058 0.583984 8.1196 0.583984 7.58337C0.583984 6.91079 0.836568 6.24521 1.16732 5.83337C1.16732 6.22015 1.32096 6.59108 1.59445 6.86457C1.86794 7.13806 2.23888 7.29171 2.62565 7.29171Z"
                    stroke="#FF5323"
                    strokeWidth="1.16667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <h3 className="font-semibold text-[15px] text-[#212326]">Current Specials</h3>
              </div>
              <div className="flex flex-wrap gap-[6px]">
                {shop?.currentSpecials?.map((special, index) => (
                  <div
                    key={index}
                    className="border border-[#FFE0D6] w-full rounded-[12px] p-[8px] flex items-start justify-between gap-[12px] bg-[#fff0ec]"
                  >

                    {/* CENTER CONTENT */}
                    <div className="flex-1 min-w-0">
                      <p className="font-semibold text-[14px] text-[#212326] leading-[18px]">
                        {special.title}
                      </p>

                      <p className="text-[13px] text-[#717182] mt-[4px] leading-[18px]">
                        {special.details}
                      </p>
                    </div>

                    {/* RIGHT BADGE */}
                    <div className="flex-shrink-0">
                      <span
                        className="px-[8px] py-[3px] rounded-[8px] text-[11px] font-semibold bg-[#ff5323] text-white"
                      >
                        {special.badgeLabel}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

        </div>

        {/* Footer */}
        <div className="shrink-0 border-t border-[#e4e5e7] px-[20px] sm:px-[24px] py-[14px] flex items-center gap-[10px] bg-white">
          {(shop.type === "shop" || shop.type === "both") &&
            <button
              className="flex-1 flex items-center justify-center gap-[6px] h-[38px] rounded-[10px] bg-[#ff5323] text-white font-semibold text-[12px] hover:bg-[#e64a1f] transition-colors"
              onClick={() => onSendFiles(shop)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-upload w-[14px] h-[14px]">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" x2="12" y1="3" y2="15"></line>
              </svg>
              Send Files
            </button>
          }

          {(shop.type === "supplier" || shop.type === "both") &&
            <button
              className="flex-1 flex items-center justify-center gap-[6px] h-[38px] rounded-[10px] border border-[#e4e5e7] text-[#212326] font-semibold text-[12px] hover:bg-[#f4f5f6] transition-colors"
              onClick={() => onQuickContact(shop)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-message-circle w-[14px] h-[14px]">
                <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
              </svg>
              Quick Contact
            </button>
          }
        </div>

      </div>
    </div>
  );
}

export default ShopDetailsModal;